// extracted by mini-css-extract-plugin
export default {"Wrapper":"WorkPermitChecklist_Wrapper__CUoxA","Instructions":"WorkPermitChecklist_Instructions__bLEbo","Name":"WorkPermitChecklist_Name__+Qgp-"};